module.exports = __webpack_public_path__ + "static/virtual-tour-abstract.b9d55c82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/virtual-tour-abstract.jpg
// module id = 350
// module chunks = 52007029612993 266772403791747